@if (value()) {
  <section class="mb-8" [attr.aria-labelledby]="heading() ? headingId : null">
    @if (heading()) {
      <div
        class="font-bold text-[1.2rem] text-inherit mb-1"
        [attr.id]="headingId"
        role="heading"
        [attr.aria-level]="headingLevel()"
      >
        {{ heading() }}
      </div>
    }
    <div class="gdpr-statement__value" data-testid="gdpr-value">
      <span [innerHTML]="value() | newlineToBr | safeHtml"></span>
      @if (afterText()) {
        <span data-testid="gdpr-after-text">
          {{ afterText() }}
        </span>
      }
    </div>
  </section>
}
